import { SidebarFeatureEnum } from 'config/types/sidebar'

export const buildSidebarTitle = (feature: SidebarFeatureEnum) => {
  if (feature === SidebarFeatureEnum.Tournament) {
    return 'Tournament'
  }
  return ''
}
